import React from "react";
import { Stack, Text, UnstyledButton } from "@mantine/core";
import styles from "./SelectableCard.module.css";

interface SelectableCardProps {
  title: string;
  /** Secondary line(s) under the title. */
  lines?: string[];
  selected: boolean;
  onSelect: () => void;
  disabled?: boolean;
}

/** Single-select option card used by the Personalize step (loyalty FE1 §2.1). */
export default function SelectableCard({
  title,
  lines = [],
  selected,
  onSelect,
  disabled = false,
}: SelectableCardProps) {
  return (
    <UnstyledButton
      className={`${styles.card}${selected ? ` ${styles.cardSelected}` : ""}`}
      onClick={onSelect}
      disabled={disabled}
      role="radio"
      aria-checked={selected}
    >
      <Stack gap={4} align="center">
        <Text fw={600} size="sm">
          {title}
        </Text>
        {lines.map((line) => (
          <Text key={line} size="sm" c="dimmed">
            {line}
          </Text>
        ))}
      </Stack>
    </UnstyledButton>
  );
}
